<template>
  <div>
    <div class="searchArea">
      <a-input v-model:value="searchName" placeholder="请输入活动名称" allow-clear style="width: 260px; margin-right: 10px;"
        @press-enter="fetchData" />
      <a-button type="primary" shape="circle" @click="fetchData">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>

      <a-button type="primary" style="margin-left: 20px" @click="handleAdd">
        <template #icon>
          <PlusOutlined />
        </template>
        新增优惠方案
      </a-button>
    </div>

    <a-table class="ant-table-striped" row-key="id" :columns="columns" :data-source="tableData" :loading="loading"
      bordered :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :pagination="{ pageSize: 12 }">
      <template #discountDesc="{ record }">
        <span>{{ getPromotionDesc(record) }}</span>
      </template>

      <template #startDate="{ text }">
        <span>{{ text || '-' }}</span>
      </template>

      <template #scope="{ record }">
        <a-space style="display: flex; align-items: center;">
          <a-select :value="record.isGlobal === false ? 'partial' : 'all'" size="small" style="width: 110px" :class = "record.isGlobal === false ? 'scope-partial' : 'scope-all'"
            @change="(value) => handleScopeChange(record, value)">
            <a-select-option value="all" >所有商品</a-select-option>
            <a-select-option value="partial" >指定商品</a-select-option>
          </a-select>
          <a-button v-if="record.isGlobal === false" type="link" size="small" @click="openBindModal(record)">
            {{ getScopeCount(record) }} ›
          </a-button>
        </a-space>
      </template>

      <template #endDate="{ text }">
        <span>{{ text || '-' }}</span>
      </template>

      <template #enabled="{ record }">
        <a-switch :checked="!!record.enabled" checked-children="启用" un-checked-children="禁用"
          :loading="!!record.__toggling" @change="handleToggleEnabled(record, $event)" />
      </template>

      <template #operation="{ record }">
        <div class="flex_sa">
          <a-tooltip title="编辑">
            <a @click="handleEdit(record)">
              <FormOutlined />
            </a>
          </a-tooltip>

          <a-popconfirm title="确定要删除此优惠方案吗？" @confirm="handleDelete(record.id)">
            <a-tooltip title="删除" style="margin-left: 12px;">
              <a class="text-danger">
                <DeleteOutlined />
              </a>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </a-table>

    <PromotionModal v-model:visible="modalVisible" :record="currentRecord" @ok="handleSuccess" />

    <PromotionProductBindModal v-model:open="bindVisible" :promotion-id="bindPromotionId"
      :initial-products="bindInitialProducts" :is-global = "bindIsGlobal" @saved="handleBindSaved" />
  </div>
</template>

<script>
import { SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { GetPromotionList, DeletePromotion, UpdatePromotionEnabled, UpdatePromotion, GetPromotionProducts } from "/src/api/shopping.js";
import PromotionModal from "/src/components/shopping/promotionModal.vue";
import PromotionProductBindModal from "/src/components/shopping/PromotionProductBindModal.vue";

export default {
  name: "优惠方案管理",
  components: {
    SearchOutlined,
    FormOutlined,
    DeleteOutlined,
    PlusOutlined,
    PromotionModal,
    PromotionProductBindModal,
  },
  data() {
    return {
      searchName: undefined,
      tableData: [],
      loading: false,
      modalVisible: false,
      currentRecord: {},
      bindVisible: false,
      bindPromotionId: undefined,
      bindInitialProducts: [],
      bindIsGlobal: false,
      
      columns: [
        { title: "活动名称", dataIndex: "name", key: "name", width: "18%" },
        { title: "优惠类型", dataIndex: "type", key: "type", width: "14%" },
        {
          title: "优惠",
          key: "discountDesc",
          width: "24%",
          slots: { customRender: "discountDesc" },
        },
        {
          title: "参与范围",
          key: "scope",
          width: "10%",
          slots: { customRender: "scope" },
        },
        {
          title: "生效日期",
          dataIndex: "startDate",
          key: "startDate",
          width: "12%",
          slots: { customRender: "startDate" },
        },
        {
          title: "失效日期",
          dataIndex: "endDate",
          key: "endDate",
          width: "12%",
          slots: { customRender: "endDate" },
        },
        {
          title: "状态",
          key: "enabled",
          width: "10%",
          slots: { customRender: "enabled" },
        },
        { title: "操作", key: "operation", width: "6%", slots: { customRender: "operation" } },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await GetPromotionList();
        if (res.errCode === 0) {
          const list = res.data || [];
          // 清掉旧缓存数量，让下方异步查询重新写入真实数量
          (Array.isArray(list) ? list : []).forEach((i) => delete i._relCount);
          const kw = (this.searchName || "").trim();
          this.tableData = kw
            ? list.filter((item) => (item.name || "").indexOf(kw) !== -1)
            : list;
          // 对"指定商品"方案异步查询真实关联数，刷新后也能显示
          (Array.isArray(this.tableData) ? this.tableData : []).forEach(async (item) => {
            if (item.isGlobal !== false) return;
            try {
              const r = await GetPromotionProducts({ promotionId: item.id });
              if (r.errCode === 0) {
                item._relCount = (Array.isArray(r.data) ? r.data : []).length;
              }
            } catch (e) {
              console.error("load rel count error:", e);
            }
          });
        } else {
          message.error(res.errMsg || "查询失败");
        }
      } catch (error) {
        console.error("fetch promotion error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    resetSearch() {
      this.searchName = undefined;
      this.fetchData();
    },
    getPromotionDesc(record) {
      if (!record) return "-";
      const cv = record.conditionValue;
      const dv = record.discountValue;
      switch (record.type) {
        case "满件减额":
          return `满 ${cv} 件，减 ${dv} 元`;
        case "满额减额":
          return `满 ${cv} 元，减 ${dv} 元`;
        case "满额折扣":
          return `满 ${cv} 元，打 ${Number(dv) * 10} 折`;
        default:
          return "-";
      }
    },
    getScopeCount(record) {
      // 优先使用绑定弹窗查询后写回的真实数量
      if (record._relCount !== undefined) return record._relCount;
      const list =
        Array.isArray(record.products) && record.products.length
          ? record.products
          : Array.isArray(record.productIds)
            ? record.productIds
            : [];
      return list.length;
    },
    handleAdd() {
      this.currentRecord = {};
      this.modalVisible = true;
    },
    handleEdit(record) {
      this.currentRecord = { ...record };
      this.modalVisible = true;
    },
    handleSuccess() {
      this.modalVisible = false;
      this.fetchData();
    },
    openBindModal(record) {
      this.bindIsGlobal = !!record.isGlobal;
      this.openBindModalById(record.id);
    },
    // 根据优惠 id 打开绑定弹窗，并查询已关联商品用于回显
    async openBindModalById(id) {
      this.bindInitialProducts = [];
      // 先查询已关联商品
      try {
        const res = await GetPromotionProducts({ promotionId: id });
        if (res.errCode === 0) {
          const list = res.data || [];
          const arr = Array.isArray(list) ? list : [];
          this.bindInitialProducts = arr.map((p) => ({ ...p }));
          // 把关联数量写回该行记录，供下拉框"指定商品(N)"显示真实数量
          const row = this.tableData.find((r) => r.id === id);
          if (row) row._relCount = arr.length;
        } else {
          message.error(res.errMsg || "查询已关联商品失败");
        }
      } catch (error) {
        console.error("fetch promotion products error:", error);
        message.error("请求异常，请稍后重试");
        return;
      }
      this.bindPromotionId = id;
      this.bindVisible = true;
    },
    handleBindSaved() {
      this.fetchData();
    },
    async handleToggleEnabled(record, checked) {
      const prev = !!record.enabled;
      record.enabled = checked;
      record.__toggling = true;
      try {
        const res = await UpdatePromotionEnabled({ id: record.id, enabled: checked });
        if (res.errCode === 0) {
          message.success(checked ? "启用完成" : "禁用完成");
        } else {
          record.enabled = prev;
          message.error(res.errMsg || "操作失败");
        }
      } catch (error) {
        record.enabled = prev;
        console.error("toggle promotion error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        record.__toggling = false;
      }
    },
    async handleDelete(id) {
      try {
        const res = await DeletePromotion({ id: id });
        if (res.errCode === 0) {
          message.success("删除成功");
          this.fetchData();
        } else {
          message.error(res.errMsg || "删除失败");
        }
      } catch (error) {
        console.error("delete promotion error:", error);
        message.error("请求异常，请稍后重试");
      }
    },
    async handleScopeChange(record, value) {
      const wantAll = value === "all";
      const targetId = record.id;
      if (!targetId) return;
      // 如果已经是目标状态，什么都不做
      if (wantAll === !!record.isGlobal) return;

      // 真正发生状态切换
      const res = await UpdatePromotion({ id: targetId, isGlobal: wantAll });
      if (res.errCode === 0) {
        record.isGlobal = wantAll;
        if (wantAll) {
          message.success("已切换为所有商品参与");
        } else {
          this.openBindModalById(targetId);
        }
      } else {
        message.error(res.errMsg || "切换参与范围失败");
      }
    },
  },
};
</script>

<style scoped>
.scope-all :deep(.ant-select-selection-item) {
  color: #52c41a;
  font-weight: 600;
}

.scope-partial :deep(.ant-select-selection-item) {
  color: #1677ff;
  font-weight: 600;
}
.flex_sa {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_sa a {
  color: rgba(0, 0, 0, 0.88);
  transition: color 0.3s;
  cursor: pointer;
  margin: 0 5px;
}

.flex_sa .text-danger {
  color: #ff4d4f;
}

</style>